import TKPI from "@/types/kpi-management/TKPI";
import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import dayjs from "dayjs";

export const hrActionManagementColumns = (
  editHandler: (val: any) => void,
  deleteHandler: (val: any) => void
) => [
  // {
  //     name: "Action ID",
  //     selector: (row: any) => row.action_id,
  //     sortable: true,
  //     wrap: true,
  // },
  {
    name: "Employee Name",
    selector: (row: any) => row.employee_name,
    sortable: true,
    wrap: true,
  },
  {
    name: "Action Type",
    selector: (row: any) => row.action_type,
    sortable: true,
    wrap: true,
  },
  {
    name: "Action Source",
    selector: (row: any) => row.action_source,
    sortable: true,
    wrap: true,
  },
  {
    name: "Amount",
    selector: (row: any) => row.amount || 0,
    sortable: true,
    wrap: true,
  },
  {
    name: "Date",
    selector: (row: any) => dayjs(row.date).format("DD-MM-YYYY"),
    sortable: false,
    wrap: true,
  },
  {
    name: "Action",
    right: true,
    selector: (row: any) => (
      <div className="flex gap-3 items-center">
        <EditButton
          id={row.action_id as any}
          actionHandler={() => editHandler(row)}
        />
        <DeleteButton
          id={row.action_id as any}
          actionHandler={() => deleteHandler(row)}
        />
      </div>
    ),
  },
];
